import { domain } from 'modules/data';
import { editRequestField, setLoadIndicatorContactCisSettings } from 'pages/requestForm/actions';
import { calculateCisDeductionBill } from 'pages/requestForm/selectors/xero/cisDeductionUtils';
import { FC, memo, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useGetContactCisSettings } from 'shared/data/webApp/v1';

import { XeroCisDeductionLine } from '../index';
import { XeroCisDeductionBillProps } from './XeroCisDeductionBill.types';

/**
 * @deprecated Old design
 */
const XeroCisDeductionBill: FC<XeroCisDeductionBillProps> = memo((props) => {
    const { contactId, companyId, lineAmountType, lineItems, currency } = props;

    const dispatch = useDispatch();

    const { data, isLoading } = useGetContactCisSettings({ query: { companyId, contactId } });

    useEffect(() => {
        dispatch(editRequestField<domain.XeroBillDetails>('contactCisSettings', data));
    }, [data, dispatch]);

    const isLoadingActive = useRef(false);

    useEffect(() => {
        if (isLoading) {
            if (!isLoadingActive.current) {
                isLoadingActive.current = true;
                dispatch(setLoadIndicatorContactCisSettings('start'));
            }
        } else if (isLoadingActive.current) {
            isLoadingActive.current = false;
            dispatch(setLoadIndicatorContactCisSettings('stop'));
        }
    }, [dispatch, isLoading]);

    useEffect(
        () => () => {
            if (isLoadingActive.current) {
                isLoadingActive.current = false;
                dispatch(setLoadIndicatorContactCisSettings('stop'));
            }
        },
        [dispatch]
    );

    if (isLoading || !data || !data.isCisEnabled || typeof data.cisRate !== 'number') {
        return null;
    }

    const cisTaxAmount = calculateCisDeductionBill(lineItems, data.cisRate, lineAmountType);

    if (typeof cisTaxAmount !== 'number') {
        return null;
    }

    return <XeroCisDeductionLine cisRate={data.cisRate} cisTaxAmount={cisTaxAmount} currency={currency} />;
});

export default XeroCisDeductionBill;
